import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import MDDatePicker from "components/MDDatepicker";
import moment from "moment";
import { addBooking } from "Apis/booking";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { updateBookingById } from "Apis/booking";
import { deleteBookingById } from "Apis/booking";
import MDTimePicker from "components/MDTimepicker";
import MDSelectBox from "components/MDSelectBox";
import dayjs from "dayjs";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";
import { statusData, BookingTagData } from "helpers/constant";
import tab from "assets/theme/components/tabs/tab";

const BookingForm = ({ bookingListData, setOpenModal, startDate, endDate, editData, deleteId }) => {
  const { showMessageNotification, formIsEdit } = useContext(ModalContext);
  const { setNotification } = useContext(LoginFormContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [selectedStartDate, setSelectedStartDate] = useState(startDate ? dayjs(startDate) : null);
  const [bookingTag, setBookingTag] = useState("");
  const [color, setColor] = useState("");
  const { error } = colors;

  const initialValues = {
    name: "",
    start_date: startDate || null,
    end_date: endDate || null,
    start_time: "",
    end_time: "",
    tag_name: "",
    color: "",
    is_active: 0,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required!"),
    start_date: Yup.date().nullable().required("Start date is required!"),
    end_date: Yup.date()
      .nullable()
      .required("End date is required!")
      .min(Yup.ref("start_date"), "End date cannot be before start date!"),
    start_time: Yup.string().required("Start time is required!").nullable(),
    end_time: Yup.string().required("End time is required!").nullable(),
    tag_name: Yup.string().required("Booking tag is required!"),
    is_active: Yup.string().required("Status is required!"),
  });

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const handleSubmit = async (values) => {
    // values.start_time = moment(values.start_time).format("hh:mm:ss");
    // values.end_time = moment(values.end_time).format("hh:mm:ss");
    values.color = color;
    if (!formIsEdit) {
      let response = await addBooking(values);
      if (response?.status === 200) {
        bookingListData();
        setOpenModal(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      // values.start_time = new Date(formik.values.start_time);
      // values.end_time = new Date(formik.values.end_time);
      let response = await updateBookingById(values);
      if (response?.status === 200) {
        bookingListData();
        setOpenModal(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    }
  };
  const setDataInFormik = async () => {
    formik.setValues(editData);

    if (editData?.start_time) {
      const startDateTime = moment(` ${editData.start_time}`, " HH:mm:ss");
      // formik.setFieldValue("start_time", startDateTime);
      formik.setFieldValue("start_time", editData?.start_time);
    }

    if (editData?.end_time) {
      const endDateTime = moment(` ${editData.end_time}`, " HH:mm:ss");
      // formik.setFieldValue("end_time", endDateTime);
      formik.setFieldValue("end_time", editData?.end_time);
    }
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setColor(editData?.color);
      setBookingTag(editData?.tag_name);
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    }
  }, []);

  const handleDelete = async () => {
    setOpenModal(false);
    showMessageNotification({
      title: "Are you sure?",
      text: "You want to delete this member!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let response = await deleteBookingById(deleteId);
        if (response?.status === 200) {
          setOpenModal(false);
          bookingListData();
          setNotification({
            color: "success",
            icon: "check",
            title: "Success",
            content: response.data.message,
            open: true,
          });
        } else {
          setNotification({
            color: "error",
            icon: "check",
            title: "error",
            content: response.data.message,
            open: true,
          });
        }
      }
    });
  };
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const handleDate = (date, fieldName) => {
    if (date) {
      const dateFormat = dayjs(date).format("YYYY-MM-DD");
      formik.setFieldValue(fieldName, dateFormat);

      if (fieldName === "start_date") {
        setSelectedStartDate(date);
        if (
          formik.values.end_date &&
          dayjs(formik.values.end_date).isBefore(dayjs(date).add(1, "day"))
        ) {
          formik.setFieldValue("end_date", "");
        }
      }
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const handleTime = (time, fieldName) => {
    if (time) {
      // formik.setFieldValue(fieldName, moment(new Date(time)));
      formik.setFieldValue(fieldName, time);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  };

  const handleAutocompleteChange = (value, name) => {
    const str_value = value ? value?.label : "";
    formik.setFieldValue(name, str_value);
    setBookingTag(value);
    if (value.label === "Marriage & Other Functions of Members") {
      setColor("#880808");
    } else if (value.label === "AGRT Functions") {
      setColor("#006400");
    } else if (value.label === "Non Member Functions") {
      setColor("#040348");
    } else {
      setColor("");
    }
  };

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <MDInput
              type="text"
              name="name"
              value={formik?.values?.name}
              label="Title"
              sx={{ width: "100%" }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="standard"
              required
            />
            {formik.touched.name && formik.errors.name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.name}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={3}>
          <Grid item xs={12} md={6}>
            <MDBox className="date__picker">
              <MDDatePicker
                width="100% !important"
                label="Start Date"
                name="start_date"
                // value={formik?.values?.start_date}
                value={formik?.values?.start_date ? dayjs(formik.values.start_date) : null}
                onChange={(date) => handleDate(date, "start_date")}
                onBlur={formik.handleBlur}
                disablePast={false}
                required
              />
              {formik.touched.start_date && formik.errors.start_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.start_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox className="date__picker">
              <MDDatePicker
                width="100% !important"
                label="End Date"
                name="end_date"
                // value={formik?.values?.end_date}
                value={formik?.values?.end_date ? dayjs(formik.values.end_date) : null}
                onChange={(date) => handleDate(date, "end_date")}
                onBlur={formik.handleBlur}
                disablePast={selectedStartDate ? false : true}
                // minDate={dayjs(selectedStartDate)}
                minDate={selectedStartDate ? dayjs(selectedStartDate) : dayjs().add(1, "day")}
                required
              />
              {formik.touched.end_date && formik.errors.end_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.end_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>
        </Grid>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={3}>
          <Grid item xs={12} md={6}>
            <MDTimePicker
              width="100% !important"
              className="time_picker"
              label="Start Time"
              name="start_time"
              value={formik?.values?.start_time || ""}
              onChange={(time) => handleTime(time, "start_time")}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.start_time && formik.errors.start_time && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.start_time}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <MDTimePicker
              width="100% !important"
              className="time_picker"
              label="End Time"
              name="end_time"
              value={formik?.values?.end_time || ""}
              onChange={(time) => handleTime(time, "end_time")}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.end_time && formik.errors.end_time && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.end_time}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <MDSelectBox
              name="tag_name"
              defaultValue={bookingTag}
              options={BookingTagData}
              handleChange={(value) => handleAutocompleteChange(value, "tag_name")}
              label="Booking Tag"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.tag_name && formik.errors.tag_name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.tag_name}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={3}>
          {/* status */}
          <Grid item xs={12} md={12}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox
          sx={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
            gap: "20px",
          }}
        >
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
          {formIsEdit && (
            <SubmitButton
              onClick={handleDelete}
              btnText="Delete"
              type="submit"
              background={error.main}
              hoverBackground={error.hover}
            />
          )}
        </MDBox>
      </MDBox>
    </>
  );
};
BookingForm.propTypes = {
  bookingListData: PropTypes.func,
  setOpenModal: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  editData: PropTypes.any,
  formIsEdit: PropTypes.bool,
  setformIsEdit: PropTypes.bool,
  deleteId: PropTypes.any,
};
export default BookingForm;
